import React from 'react'
import AlertEventDetailTable from './AlertEventDetailTable'
import { FilterDataProvider } from '../../HOC/alertsFiltersContext'
import { AlertEventDetailFiltersForm } from './AlertEventDetailFiltersForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function AlertEventsDetail() {
  SetTitle('SEO Sentinel Alerts')
	return (
    <Header
      iconClass="ni ni-compass-04 text-white"
      title="SEO Sentinel Alerts"
      headerClassName="main-page-title"
    >
      <FilterDataProvider>
        <AlertEventDetailFiltersForm />
        <AlertEventDetailTable />
      </FilterDataProvider>
    </Header>
	)
}